module.exports = __webpack_public_path__ + "img/grade.441f0d81.svg";